const wishlistTriggers = [...document.querySelectorAll(".js-productblock")];

export const wishlistTriggersInit = wishlistTrigger => {

    wishlistTrigger.querySelector('a').addEventListener('click', (e) => {
        if(e.target.classList.contains('js-wishlist-trigger-svg')){
            e.preventDefault();
        }
    });
}

wishlistTriggers.map(wishlistTriggersInit);

window.addEventListener('slider.updated', () => {
    const wishlistTriggers = [...document.querySelectorAll(".js-productblock")];
    wishlistTriggers.map(wishlistTriggersInit);
});
